var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBurger = function SvgMenuBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "menu-burger_svg__a",
    d: "M4.5 8.514a.5.5 0 0 1 0-1h7.027a.5.5 0 1 1 0 1H4.5zm0 2.513a.5.5 0 1 1 0-1h7.027a.5.5 0 1 1 0 1H4.5zM4.5 6a.5.5 0 0 1 0-1h7.027a.5.5 0 1 1 0 1H4.5z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#25292D",
    xlinkHref: "#menu-burger_svg__a"
  })));
};
export default SvgMenuBurger;